export const dateFormat = (val) => {
  if (!val) {
    return '-'
  } else {
    const year = new Date(val).getFullYear();
    const month = new Date(val).getMonth() + 1;
    // const date = new Date(val).getDate();
    const monthFormat = month > 9 ? month : '0' + month;
    // const dateFormat = date > 9 ? date : '0' + date;
    const dateResult = year + '-' + monthFormat;
    return dateResult
  }
}
export const dateFormat2021 = (val) => {
  if (!val) {
    return '-'
  } else {
    const year = new Date(val).getFullYear();
    const month = new Date(val).getMonth() + 1;
    const date = new Date(val).getDate();
    const monthFormat = month > 9 ? month : '0' + month;
    const dateFormat = date > 9 ? date : '0' + date;
    const dateResult = year + '-' + monthFormat + '-' + dateFormat;
    return dateResult
  }
}
export const dayFormat = (value) => {
  if (!value) {
    return '-'
  } else {
    const val = value.replace(/\-/g, "/");
    const month = new Date(val).getMonth() + 1;
    const date = new Date(val).getDate();
    const monthFormat = month > 9 ? month : '0' + month;
    const dateFormat = date > 9 ? date : '0' + date;
    const dateResult = monthFormat + "月" + dateFormat + "日";
    return dateResult
  }
}
